import api from "utils/axiosInstance";
import URL from "./apiURL";


export async function updateIncidentPriority(payload) {
  try {
    const res = await api.patch(URL.updateIncidentPriorityApi, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Error updating the priority:", error);
    throw error;
  }
}
